const upcomingEventList = document.querySelector(".upcoming-shoot-list");

const gunClubData = [
  {
    clubName: "PRO GUN CLUB",
    clubWebsite: "https://www.progunvegas.com/",
  },
  {
    clubName: "VEGAS SKEET & SPORTING CLAYS",
    clubWebsite:
      "https://www.clarkcountynv.gov/government/departments/parks___recreation/shooting_complex/index.php",
  },
  {
    clubName: "CLARK COUNTY SHOOTING COMPLEX",
    clubWebsite:
      "https://www.clarkcountynv.gov/government/departments/parks___recreation/shooting_complex/index.php",
  },
  {
    clubName: "WALKER RIVER RESORT S/C",
    clubWebsite: "https://www.wrresort.com/sporting-clays/",
  },
  {
    clubName: "PERDIZ SPORTS SHOOTING INC",
    clubWebsite:
      "https://www.eurekacountynv.gov/recreation-culture-in-eureka-county/perdiz-sport-shooting/",
  },
  {
    clubName: "SPRING CREEK TRAP & SKEET",
    clubWebsite: "https://www.springcreeknv.org/trap-and-skeet",
  },
  {
    clubName: "CARSON VALLEY TRAP & S/C",
    clubWebsite: "https://www.carsonvalleyclays.com/",
  },
  {
    clubName: "CAPITOL CITY GUN CLUB",
    clubWebsite: "http://www.capitolcitygunclub.org/",
  },
];

const upcomingEventsData = [
  {
    shootName: "DESERT BIGHORN SHEEP",
    startDate: "01/01/2022",
    endDate: "01/01/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "JANUARY FUN SHOOT",
    startDate: "01/29/2022",
    endDate: "01/29/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "COYOTE",
    startDate: "02/08/2022",
    endDate: "02/08/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FEBRUARY  FUN SHOOT",
    startDate: "02/26/2022",
    endDate: "02/26/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "DESERT TORTOISE",
    startDate: "03/05/2022",
    endDate: "03/05/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "DUCKS UNLIMITED LAS VEGAS CONTINENTAL",
    startDate: "03/03/2022",
    endDate: "03/06/2022",
    clubName: "CLARK COUNTY SHOOTING COMPLEX",
  },
  {
    shootName: "MARCH FUN SHOOT",
    startDate: "03/19/2022",
    endDate: "03/19/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "MARCH OPEN",
    startDate: "03/20/2022",
    endDate: "03/20/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "GILA MONSTER",
    startDate: "04/02/2022",
    endDate: "04/02/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "04/02/2022",
    endDate: "04/02/2022",
    clubName: "WALKER RIVER RESORT S/C",
  },
  {
    shootName: "APRIL FUN SHOOT",
    startDate: "04/23/2022",
    endDate: "04/23/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "300 SUPER SPORT",
    startDate: "04/23/2022",
    endDate: "04/24/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "BURROWING OWL",
    startDate: "05/07/2022",
    endDate: "05/07/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "05/14/2022",
    endDate: "05/14/2022",
    clubName: "CAPITOL CITY GUN CLUB",
  },
  {
    shootName: "SILVER BUCKLE",
    startDate: "05/28/2022",
    endDate: "05/28/2022",
    clubName: "CARSON VALLEY TRAP & S/C",
  },
  {
    shootName: "MAY FUN SHOOT",
    startDate: "05/28/2022",
    endDate: "05/28/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "MAY OPEN",
    startDate: "05/29/2022",
    endDate: "05/29/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "BLACK-TAILED JACKRABBIT",
    startDate: "06/04/2022",
    endDate: "06/04/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "SMALL GAUGE WEEKEND/20,28,410",
    startDate: "06/11/2022",
    endDate: "06/12/2022",
    clubName: "CARSON VALLEY TRAP & S/C",
  },
  {
    shootName: "JUNE OPEN",
    startDate: "06/12/2022",
    endDate: "06/12/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "JUNE FUN SHOOT",
    startDate: "06/25/2022",
    endDate: "06/25/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "GREAT BASIN RATTLESNAKE",
    startDate: "07/02/2022",
    endDate: "07/02/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "07/09/2022",
    endDate: "07/09/2022",
    clubName: "WALKER RIVER RESORT S/C",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "07/16/2022",
    endDate: "07/16/2022",
    clubName: "CAPITOL CITY GUN CLUB",
  },
  {
    shootName: "JULY OPEN",
    startDate: "07/17/2022",
    endDate: "07/17/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "JULY FUN SHOOT",
    startDate: "07/23/2022",
    endDate: "07/23/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "PUPFISH",
    startDate: "08/06/2022",
    endDate: "08/06/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "08/06/2022",
    endDate: "08/06/2022",
    clubName: "WALKER RIVER RESORT S/C",
  },
  {
    shootName: "WALK-A-BOUT",
    startDate: "08/05/2022",
    endDate: "08/07/2022",
    clubName: "PERDIZ SPORTS SHOOTING INC",
  },
  {
    shootName: "PRE STATE SHOOT",
    startDate: "08/20/2022",
    endDate: "08/20/2022",
    clubName: "CARSON VALLEY TRAP & S/C",
  },
  {
    shootName: "AUGUST FUN SHOOT",
    startDate: "08/27/2022",
    endDate: "08/27/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "BIG GAME SHOOT",
    startDate: "08/26/2022",
    endDate: "08/28/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "GIANT HAIRY SCORPION",
    startDate: "09/03/2022",
    endDate: "09/03/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "SEPTEMBER OPEN",
    startDate: "09/18/2022",
    endDate: "09/18/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "SEPTEMBER FUN SHOOT",
    startDate: "09/24/2022",
    endDate: "09/24/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "WILD MUSTANG",
    startDate: "10/01/2022",
    endDate: "10/01/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "10/08/2022",
    endDate: "10/08/2022",
    clubName: "CAPITOL CITY GUN CLUB",
  },
  {
    shootName: "OCTOBER OPEN",
    startDate: "10/16/2022",
    endDate: "10/16/2022",
    clubName: "SPRING CREEK TRAP & SKEET",
  },
  {
    shootName: "FALL REGISTERED SHOOT",
    startDate: "10/28/2022",
    endDate: "10/28/2022",
    clubName: "CARSON VALLEY TRAP & S/C",
  },
  {
    shootName: "OCTOBER FUN SHOOT",
    startDate: "10/29/2022",
    endDate: "10/29/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "FUN SHOOT",
    startDate: "11/05/2022",
    endDate: "11/05/2022",
    clubName: "CAPITOL CITY GUN CLUB",
  },
  {
    shootName: "RED-TAILED HAWK",
    startDate: "11/05/2022",
    endDate: "11/05/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "NOVEMBER FUN SHOOT",
    startDate: "11/26/2022",
    endDate: "11/26/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
  {
    shootName: "GRAY FOX",
    startDate: "12/03/2022",
    endDate: "12/03/2022",
    clubName: "PRO GUN CLUB",
  },
  {
    shootName: "DECEMBER FUN SHOOT",
    startDate: "12/31/2022",
    endDate: "12/31/2022",
    clubName: "VEGAS SKEET & SPORTING CLAYS",
  },
];

if (upcomingEventList) {
  upcomingEventsData.forEach((el) => {
    for (let i = 0; i < gunClubData.length; i++) {
      if (el.clubName === gunClubData[i].clubName) {
        el.clubWebsite = gunClubData[i].clubWebsite;
      }
    }
  });

  const currDate = Date.now();

  const upcomingShoots = upcomingEventsData.filter((el) => {
    const startDate = new Date(el.startDate);
    if (startDate > currDate) return new Object({ el });
  });

  upcomingShoots.slice(0, 6).map((el, i) => {
    const shootName = el.shootName;
    const clubName = el.clubName;
    const startDate = new Date(el.startDate);
    const endDate = new Date(el.endDate);
    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const clubWebsite = el.clubWebsite;

    if (startDate.getTime() !== endDate.getTime()) {
      const outputHTML = `
    <li class="upcoming-shoot-item">
    <div>
    <h3>${shootName}</h3>
    <a target="_blank" href=${clubWebsite}  class="indent">${clubName}</a>
    <p class="indent">${startDate.toLocaleDateString(
      "us-en",
      dateOptions
    )} - ${endDate.toLocaleDateString("us-en", dateOptions)}</p>
    </div>
    </li>`;

      upcomingEventList.insertAdjacentHTML("beforeend", outputHTML);
    }

    if (startDate.getTime() === endDate.getTime()) {
      const outputHTML = `
    <li class="upcoming-shoot-item">
    <div>
    <h3>${shootName}</h3>
    <a target="_blank" href=${clubWebsite}  class="indent">${clubName}</a>
    <p class="indent">${startDate.toLocaleDateString("us-en", dateOptions)}</p>
    </div>
    </li>`;

      upcomingEventList.insertAdjacentHTML("beforeend", outputHTML);
    }
  });
}

const shootPage = document.querySelector(".club-shoot-list");

if (shootPage) {
  const clarkCounty = document.querySelector(".clark-county");
  const proGun = document.querySelector(".pro-gun");
  const walkerRiver = document.querySelector(".walker-river");
  const perdizSports = document.querySelector(".perdiz-sports");
  const springCreek = document.querySelector(".spring-creek");
  const cvc = document.querySelector(".cvc");
  const ccgc = document.querySelector(".ccgc");

  upcomingEventsData.forEach((el) => {
    for (let i = 0; i < gunClubData.length; i++) {
      if (el.clubName === gunClubData[i].clubName) {
        el.clubWebsite = gunClubData[i].clubWebsite;
      }
    }
  });

  const currDate = Date.now();

  const upcomingShoots = upcomingEventsData.filter((el) => {
    const startDate = new Date(el.startDate);
    if (startDate > currDate) return new Object({ el });
  });

  function outputHTML(shootLocation, shootName, startDate, endDate) {
    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const html = `
  <li class="upcoming-shoot-item">
  <div>
  <h3>${shootName}</h3>
  <p class="indent">${startDate.toLocaleDateString(
    "us-en",
    dateOptions
  )} - ${endDate.toLocaleDateString("us-en", dateOptions)}</p>
  </div>
  </li>`;
    shootLocation.insertAdjacentHTML("beforeend", html);
  }

  upcomingShoots
    .filter((el) => {
      if (el.clubName === "SPRING CREEK TRAP & SKEET") {
        const eachClub = Object.assign(el, { shootLocation: springCreek });
        return eachClub;
      }
      if (el.clubName === "PRO GUN CLUB") {
        const eachClub = Object.assign(el, { shootLocation: proGun });
        return eachClub;
      }
      if (el.clubName === "CAPITOL CITY GUN CLUB") {
        const eachClub = Object.assign(el, { shootLocation: ccgc });
        return eachClub;
      }
      if (
        el.clubName === "VEGAS SKEET & SPORTING CLAYS" ||
        el.clubName === "CLARK COUNTY SHOOTING COMPLEX"
      ) {
        const eachClub = Object.assign(el, { shootLocation: clarkCounty });
        return eachClub;
      }
      if (el.clubName === "WALKER RIVER RESORT S/C") {
        const eachClub = Object.assign(el, { shootLocation: walkerRiver });
        return eachClub;
      }
      if (el.clubName === "PERDIZ SPORTS SHOOTING INC") {
        const eachClub = Object.assign(el, { shootLocation: perdizSports });
        return eachClub;
      }
      if (el.clubName === "CARSON VALLEY TRAP & S/C") {
        const eachClub = Object.assign(el, { shootLocation: cvc });
        return eachClub;
      }
    })
    .map((el) => {
      const shootName = el.shootName;
      const startDate = new Date(el.startDate);
      const endDate = new Date(el.endDate);
      const shootLocation = el.shootLocation;

      outputHTML(shootLocation, shootName, startDate, endDate);
    });
}
